import { process, State } from '@progress/kendo-data-query';
import { GridDataStateChangeEvent, GridDetailRowProps } from '@progress/kendo-react-grid';
import { GridSelectableSettings } from '@progress/kendo-react-grid/dist/npm/interfaces/GridSelectableSettings';
import { FC, useCallback, useState } from 'react';
import { subChildAccrualReportColumns } from 'src/assets/static/accrual-report/useAccrualColumn';
import GridWrapper from 'src/components/GridWrapper';

const selectable: GridSelectableSettings = {
  enabled: false,
  drag: false,
  cell: false,
};

const defaultProps = {
  tableTextId: 'LineItems',
  DataItemKey: 'rowId',
  sortable: true,
  resizable: true,
  showColumnMenu: true,
  selectable: selectable,
  pageable: false,
} as const;

const AccrualSubChild: FC<GridDetailRowProps> = (props) => {
  const [state, setState] = useState<State>({ skip: 0 });
  const handleDataStateChange = useCallback((e: GridDataStateChangeEvent) => {
    setState(e.dataState);
  }, []);
  const { data, total } = process(props.dataItem.lineItems, state);

  return (
    <main className="mt-2">
      <GridWrapper
        id="AccrualSubChild"
        columns={subChildAccrualReportColumns}
        dataSource={data}
        total={total}
        {...defaultProps}
        noRecordText="No records to display"
        dataState={state}
        onDataStateChange={handleDataStateChange}
        className="no_Veritcal_ScrollBar"
        hideScrollBar
      />
    </main>
  );
};

export default AccrualSubChild;
